<script lang="ts">
    import { t } from 'svelte-i18n';
    import ContactButtonBSA from '$lib/components/ContactButtonBSA.svelte';

    import zfBackgroundImg from '$lib/assets/images/partner/zf-background.webp'; // backgroundImage

    import zfBmwImg from '$lib/assets/images/partner/zf-bmw.png?as=run&w=890'; // xd export
    import zfCarbonClutchImg from '$lib/assets/images/partner/zf-carbon-clutch.png?as=run:0&w=448=avif;webp'; // max file Size
    import zfClutchImg from '$lib/assets/images/partner/zf-clutch.png?as=run:0&w=500=avif;webp'; // max file Size
    import zfCollageAImg from '$lib/assets/images/partner/zf-collage-a.png?as=run&w=1835'; // xd export
    import zfCollageBImg from '$lib/assets/images/partner/zf-collage-b.png?as=run&w=1835'; // xd export
    import zfCompanyImg from '$lib/assets/images/partner/zf-company.png?as=run&w=500'; // max file Size
    import zfLogoImg from '$lib/assets/images/partner/zf-logo.png?as=run:0&w=500&format=avif;webp'; // max file Size
    import Img from '@zerodevx/svelte-img';
</script>

<svelte:head>
    <title>{$t('website.page.zf.meta.title')}</title>
    <meta name="description" content={$t('website.page.zf.meta.description')} />
</svelte:head>

<div class="partner-page">
    <!-- Hero ZF -->
    <section
        id="zf-a"
        class="bg-no-repeat bg-cover bg-bottom overflow-hidden"
        style="background-image: url('{zfBackgroundImg}');"
    >
        <div class="min-h-screen w-full flex flex-col justify-center container mx-auto px-5">
            <div>
                <Img
                    class="opacity-10 min-w-[340px] w-[47vw] max-w-[900px]"
                    src={zfLogoImg}
                    alt={$t('website.page.zf.a.imageAlt.1')}
                    loading="eager"
                />
                <Img
                    class="mt-[-1.9rem] sm:mt-[-4.8vw] ml-[4.8vw] min-w-[240px] w-[26vw] max-w-[500px]"
                    src={zfLogoImg}
                    alt={$t('website.page.zf.a.imageAlt.1')}
                    loading="eager"
                />

                <button
                    class="btn-primary-bsa ml-[4.8vw]"
                    on:click|preventDefault={() =>
                        window.scrollTo({
                            top: document.getElementById('zf-a')?.clientHeight,
                            behavior: 'smooth'
                        })}
                >
                    {$t('website.page.zf.a.button')}
                </button>
            </div>
        </div>
    </section>

    <!-- ZF Motorsport Race Engineering -->
    <section id="zf-b">
        <div class="w-full flex flex-col lg:flex-row-reverse justify-center container mx-auto px-5 gap-x-12 mt-32">
            <div class="w-full mb-5 lg:mb-0 lg:w-1/2 ml-5 -mr-5 lg:ml-0 max-w-fit">
                <div
                    class="relative lg:ml-5
                    lg:before:content-[''] lg:before:border-secondary lg:before:border-2 lg:before:absolute lg:before:w-[80%] lg:before:h-[225%] lg:before:top-[75%] lg:before:-ml-[15%]
                    xl:before:h-[200%] xl:before:-ml-[25%]
                    after:content-[''] after:bg-secondary after:absolute after:w-full after:h-full after:top-5 after:-ml-5"
                >
                    <Img class="relative z-10" src={zfCompanyImg} alt={$t('website.page.zf.b.imageAlt.1')} />
                </div>
            </div>

            <div class="w-full lg:w-1/2">
                <div class="mb-6 lg:mb-16 xl:mb-32 mt-10 lg:mt-0 xl:mt-10">
                    <h3 class="h3 mb-3 block">{@html $t('website.page.zf.b.caption')}</h3>
                    <h3 class="h3 grey-stroke block">{$t('website.page.zf.b.subcaption')}</h3>
                </div>

                <div class="w-full lg:w-5/6 xl:w-2/3">
                    <p>{@html $t('website.page.zf.b.text')}</p>
                    <ContactButtonBSA label={$t('website.page.zf.b.button')} />
                </div>
            </div>
        </div>
    </section>

    <!-- Image Gallery A -->
    <section id="zf-c" class="overflow-hidden mt-16 lg:mt-0">
        <div
            class="z-[-1] relative flex flex-col justify-center lg:container mx-auto px-0 xl:px-5 mt-16 lg:mt-32 w-[260%] sm:w-full left-[-80%] sm:left-0"
        >
            <Img src={zfCollageAImg} alt={$t('website.page.zf.c.imageAlt.1')} />
        </div>
    </section>

    <!-- ZF Performance Kupplungen -->
    <section id="zf-d">
        <div class="min-h-screen w-full container mx-auto px-5 mt-40">
            <div class="flex gap-x-32 flex-col lg:flex-row justify-center">
                <div class="w-full lg:w-1/3 mb-6 lg:mb-5">
                    <h3 class="h3 mb-3 block">{$t('website.page.zf.d.caption')}</h3>
                    <h3 class="h3 grey-stroke block">{@html $t('website.page.zf.d.subcaption')}</h3>
                </div>

                <p class="w-full lg:w-1/3">{@html $t('website.page.zf.d.top.text')}</p>
            </div>

            <div class="flex gap-x-32 flex-col lg:flex-row justify-center mt-8 lg:mt-48">
                <div
                    class="relative lg:mt-5
                    lg:before:content-[''] lg:before:z-[-1] lg:before:border-secondary lg:before:border-2 lg:before:absolute lg:before:w-[150%] lg:before:h-[300%] lg:before:bottom-[35%] lg:before:-ml-[55%]
                    xl:before:-ml-[110%]"
                >
                    <Img class="relative z-10" src={zfClutchImg} alt={$t('website.page.zf.d.imageAlt.1')} />
                </div>

                <p class="w-full lg:w-1/3 mt-10 lg:mt-0">{@html $t('website.page.zf.d.bottom.text')}</p>
            </div>
        </div>
    </section>

    <!-- Partner -->
    <section id="zf-e" class="overflow-hidden">
        <div class="min-h-screen w-full flex flex-col justify-center container mx-auto px-5 mt-16 lg:mt-40">
            <div>
                <h2
                    class="h2 block left-12 grey-stroke text-greyoutlinetitle sm:text-greyoutlinetitle_sm lg:text-greyoutlinetitle_lg xl:text-greyoutlinetitle_xl"
                >
                    {$t('website.page.zf.e.caption')}
                </h2>
                <h2 class="h2 -mt-28 after:bg-white">{$t('website.page.zf.e.caption')}</h2>
            </div>
            <div class="w-full lg:w-1/2 xl:w-1/3 mt-12 lg:mt-20 xl:mt-32 lg:ml-32">
                <p>{@html $t('website.page.zf.e.text')}</p>
                <ContactButtonBSA label={$t('website.page.zf.e.button')} />
            </div>
        </div>
    </section>

    <!-- BMW Image -->
    <section id="zf-f">
        <div
            class="my-40 w-full flex justify-center
            lg:before:content-[''] lg:before:border-secondary lg:before:border-l-2 lg:before:border-y-2 lg:before:absolute lg:before:w-[47.9%] lg:before:ml-[52%] lg:before:h-[140%] lg:before:bottom-[55%]
            xl:before:h-[160%] xl:before:bottom-[62%]
        "
        >
            <Img class="relative z-10" src={zfBmwImg} alt={$t('website.page.zf.f.imageAlt.1')} />
        </div>
    </section>

    <!-- Image Gallery A -->
    <section id="zf-g" class="overflow-hidden mt-16 lg:mt-0">
        <div
            class="z-[-1] relative flex flex-col justify-center lg:container mx-auto px-0 xl:px-5 mt-16 lg:mt-32 w-[260%] sm:w-full left-[-80%] sm:left-0"
        >
            <Img src={zfCollageBImg} alt={$t('website.page.zf.g.imageAlt.1')} />
        </div>
    </section>

    <!-- Vollcarbon Kupplung -->
    <section id="pagid-h">
        <div
            class="min-h-screen w-full flex flex-col lg:flex-row-reverse justify-center container mx-auto px-5 gap-x-12 mt-32 mb-32"
        >
            <div class="w-full lg:w-1/2 flex flex-col justify-center">
                <div class="w-full lg:w-1/4 mb-6 lg:mb-16">
                    <h3 class="h3 mb-3 block">{$t('website.page.zf.h.caption')}</h3>
                    <h3 class="h3 grey-stroke block">{$t('website.page.zf.h.subcaption')}</h3>
                </div>

                <p class="w-full lg:w-5/6 xl:w-2/3">{@html $t('website.page.zf.h.text')}</p>
            </div>

            <div class="w-3/4 lg:w-3/4 mt-8 lg:mb-0 lg:ml-0">
                <div
                    class="relative lg:ml-5 lg:w-3/5
                    lg:before:content-[''] lg:before:z-[-1] lg:before:border-secondary lg:before:border-2 lg:before:absolute lg:before:w-[150%] lg:before:h-[300%] lg:before:bottom-[35%] lg:before:-ml-[55%]
                    xl:before:-ml-[110%]"
                >
                    <Img class="relative z-10" src={zfCarbonClutchImg} alt={$t('website.page.zf.h.imageAlt.1')} />
                </div>
            </div>
        </div>
    </section>
</div>
